import { formatDocument } from "../../../utils/utils";

const Sociedade = ({ socios, canFormatDocument = true }) => {
  const isEmpty = (val) => val == null || val === "" || val === "-";

  const hasCpf = socios?.some((s) => !isEmpty(s?.cpf));
  const hasCargo = socios?.some((s) => !isEmpty(s?.cargo));
  const hasParticipacao = socios?.some(
    (s) =>
      !isEmpty(s?.participacaoEmPorcentagem) ||
      !isEmpty(s?.percentualParticipacao)
  );
  const hasRestricoes = socios?.some((s) => s?.temRestricoes != null);

  const colCount =
    3 + // Nº (1) + Nome (col-span-2)
    (hasCpf ? 1 : 0) +
    (hasCargo ? 1 : 0) +
    (hasParticipacao ? 1 : 0) +
    (hasRestricoes ? 1 : 0);

  const gridStyle = {
    gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
  };

  return (
    <>
      <div className="mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div
            className="grid gap-2 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500"
            style={gridStyle}
          >
            <div className="text-center">Nº</div>
            <div className="col-span-2">Nome</div>
            {hasCpf && <div className="text-center">CPF</div>}
            {hasCargo && <div className="text-center">Cargo</div>}
            {hasParticipacao && <div className="text-center">Part. (%)</div>}
            {hasRestricoes && <div className="text-center">Restrição</div>}
          </div>
        </div>

        {socios?.length > 0 && (
          <div className="divide-y divide-slate-100">
            {socios?.map((socio, index) => (
              <div
                key={index}
                className={`grid gap-2 px-4 py-3 text-sm items-center ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                } hover:bg-slate-50`}
                style={gridStyle}
              >
                <div className="text-center font-medium text-slate-700">
                  {index + 1}
                </div>
                <div className="col-span-2">
                  <div className="font-medium text-slate-900">
                    {socio?.nome || "-"}
                  </div>
                </div>
                {hasCpf && (
                  <div className="text-center text-slate-700">
                    {socio?.cpf
                      ? canFormatDocument
                        ? formatDocument(socio?.cpf)
                        : socio?.cpf
                      : "-"}
                  </div>
                )}
                {hasCargo && (
                  <div className="text-center text-slate-700">
                    {socio?.cargo || "-"}
                  </div>
                )}
                {hasParticipacao && (
                  <div className="text-center text-slate-700">
                    {socio?.participacaoEmPorcentagem ||
                      socio?.percentualParticipacao ||
                      "-"}
                  </div>
                )}
                {hasRestricoes && (
                  <div className="text-center text-slate-700">
                    {socio?.temRestricoes == null
                      ? "-"
                      : socio.temRestricoes
                      ? "Sim"
                      : "Não"}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Sociedade;
